export enum EnumRegionImpuestos {
  Peninsula = 1,
  IslasCanarias,
  IslasBaleares,
  Ceuta = 4,
  Melilla = 5,
  PortugalContinental = 1001,
  PortugalAzores = 1002,
  PortugalMadeira = 1003
}
